import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";

class QuickExchangeInitStep extends StepFlow {
    get stepName() { return "QuickExchangeInitStep_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {        
        this.next()
    }
}

export const quickExchangeInitStepDeclaration = new StepDefinition({
    stepName: "QuickExchangeInitStep_Step",
    stepClass: QuickExchangeInitStep
});